<div *mobxAutorun="{}">
  <!---

  <div class="header-container flex justify-content-between">
    <div class="flex flex-column align-self-end text-xs">
      E: {{ store.windowStart | datex : 'ddd DD MMM HH:mm' }}
    </div>
    <div class="progress-step-item" style="width: 30%">
      <div
        class="progress-step-item-title"
        [class.pick-up]="!isDropOff"
        [class.drop-off]="isDropOff"
      >
        <span>{{ isDropOff ? 'Delivery' : 'Collection' }}</span>
      </div>
    </div>
    <div class="flex flex-column align-self-end text-right text-xs">
      L: {{ store.windowEnd | datex : 'ddd DD MMM HH:mm' }}
    </div>
  </div>
  <div class="progress-line-container">
    <div class="progress-step-item" style="width: 100%">
      <div class="progress-line"></div>
      <span class="progress-step-item-number"></span>
    </div>
  </div>
  <div class="date-container flex justify-content-between text-center">
    <div></div>
    <div>
      <ng-container *ngIf="store">
        <span class="mt-2">{{ store.scheduledTime | datex : "ddd DD MMM 'YY" }}</span>
        <br />
        <span class="mt-2">{{ store.scheduledTime.getHours() | hourBand : isDropOff }}</span>
        <br />
        <div class="w-full flex align-items-end justify-content-center">
          <span
            [ngClass]="{
              'text-green-600': store.isScheduledTimeInWindow,
              'text-orange-600': !store.isScheduledTimeInWindow
            }"
            >{{ store.validationText }}</span
          >
        </div>
      </ng-container>
    </div>
    <div></div>
  </div>

  -->
</div>
